<template>
  <div class="quill" :name="name" :style="`height: ${height}px`"></div>
</template>

<script>
  import Quill from 'quill'

  export default {
    props: {
      height: {
        required: false,
        type: Number,
        default: 200
      },
      placeholder: {
        required: false,
        type: String,
        default: ''
      },
      value: {
        required: false
      },
      name: {
        required: false,
        type: String
      }
    },

    data () {
      return {
        quill: null
      }
    },

    mounted () {
      let options = {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline']
          ]
        },
        placeholder: this.placeholder || ''
      }

      this.quill = new Quill(this.$el, options)

      this.quill.on('text-change', (delta, oldDelta, source) => {
        if (source === 'api') return
        if (this.quill.container.querySelector('.ql-editor').innerText.replace(/\n/, '') === '') {
          this.$emit('input', null)
        } else {
          this.$emit('input', this.quill.container.querySelector('.ql-editor').innerHTML)
        }
      })
    },

    watch: {
      value (newValue, oldValue) {
        if (!this.value) {
          this.quill.deleteText(0, oldValue.length, 'silent')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Quill.vue?df2b5188